import { logger } from '@/lib/utils/logger';

/**
 * Newsletter abonelik işlemleri için API servisi
 */
export class NewsletterAPI {
  /**
   * Yeni bir newsletter abonesi oluşturur
   */
  static async subscribe(email: string): Promise<{ success: boolean; error?: string }> {
    try {
      // API URL'sini belirle
      let apiUrl = '/api/newsletter';

      if (typeof window === 'undefined') {
        // Server-side
        apiUrl = process.env.NEXT_PUBLIC_PAYLOAD_API_URL
          ? `${process.env.NEXT_PUBLIC_PAYLOAD_API_URL}/api/newsletter-subscribers`
          : 'http://localhost:3030/api/newsletter-subscribers';
      }

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch((): null => null);

        // Duplicate email check
        if (response.status === 400 && errorData?.errors?.[0]?.message?.includes('unique')) {
          return { success: false, error: 'This email is already subscribed.' };
        }

        return { success: false, error: 'Subscription failed. Please try again.' };
      }

      return { success: true };
    } catch (error) {
      logger.error(`An error occurred while creating a newsletter subscriber:`, error);
      return { success: false, error: 'Subscription failed. Please try again.' };
    }
  }
}

export async function subscribeToNewsletter(email: string, title: string, dropDate: string) {
  try {
    const base = process.env.NEXT_PUBLIC_PAYLOAD_API_URL?.replace(/\/+$/, '')
    const apiUrl = base
      ? `${base}/api/event-reminder`
      : typeof window !== 'undefined'
        ? '/api/event-reminder'
        : 'http://localhost:3030/api/event-reminder'

    // API'ye istek gönder
 await fetch(apiUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        title,
        dropDate,
      }),
    });

    return true;
  } catch (error) {
    logger.error('Newsletter subscription error:', error);
    throw error;
  }
}
